"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatIcon = function ChatIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "26px", height: "26px", viewBox: "0 0 26 26", version: "1.1" },
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-37.000000, -608.000000)" },
        _react2.default.createElement(
          "g",
          { transform: "translate(0.000000, 540.000000)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(25.000000, 59.000000)" },
            _react2.default.createElement(
              "g",
              { transform: "translate(12.000000, 9.000000)" },
              _react2.default.createElement("rect", { x: "0", y: "0", width: "26", height: "26" }),
              _react2.default.createElement(
                "g",
                { transform: "translate(3.033333, 4.333333)" },
                _react2.default.createElement(
                  "g",
                  { fill: "#ACC9FF" },
                  _react2.default.createElement("path", { d: "M1.67268286,1.23160741e-14 C0.716853192,1.23160741e-14 0,0.814813482 0,1.71111611 L0,12.6851715 C0,13.6629633 0.796512017,14.3 1.67268286,14.3 L2.71975809,14.3 L2.71975809,17.7666667 L6.30402405,14.3 L18.2606505,14.3 C19.2164801,14.3 19.9333333,13.5814742 19.9333333,12.6851715 L19.9333333,1.71111611 C19.9333333,0.733324336 19.1368213,1.23160741e-14 18.2606505,1.23160741e-14 L1.67268286,1.23160741e-14 Z" })
                ),
                _react2.default.createElement("path", {
                  d: "M4.98337303,5.2 C5.82100336,5.2 6.5,5.87909381 6.5,6.71674606 C6.5,7.55431892 5.82100336,8.23333333 4.98337303,8.23333333 C4.1457427,8.23333333 3.46666667,7.55431892 3.46666667,6.71674606 C3.46666667,5.87909381 4.1457427,5.2 4.98337303,5.2",
                  fill: "#417FD0"
                }),
                _react2.default.createElement("path", {
                  d: "M10.1832936,5.2 C11.020924,5.2 11.7,5.87909381 11.7,6.71674606 C11.7,7.55431892 11.020924,8.23333333 10.1832936,8.23333333 C9.34566331,8.23333333 8.66666667,7.55431892 8.66666667,6.71674606 C8.66666667,5.87909381 9.34566331,5.2 10.1832936,5.2",
                  fill: "#6694D8"
                }),
                _react2.default.createElement("path", {
                  d: "M15.3832936,5.2 C16.220924,5.2 16.9,5.87909381 16.9,6.71674606 C16.9,7.55431892 16.220924,8.23333333 15.3832936,8.23333333 C14.5456633,8.23333333 13.8666667,7.55431892 13.8666667,6.71674606 C13.8666667,5.87909381 14.5456633,5.2 15.3832936,5.2",
                  fill: "#FFFFFF"
                })
              )
            )
          )
        )
      )
    )
  );
};

exports.default = ChatIcon;